<div *ngIf="isBilled" class="w-full px-8">
  <div class="grid grid-cols-4 gap-1 text-base font-semibold">
    <div>Bill Number</div>
    <div>Date</div>
    <div>Billed</div>
    <div>Written Off</div>
  </div>
  <div *ngFor="let row of billDetailRows">
    <div class="grid grid-cols-4 gap-1">
      <div>
        <a
          class="bluelink"
          [routerLink]="['/apps', 'job', adminId, 'time', 'billing', 'invoice', row.billId]">{{
          row.billNumber }}</a>
      </div>
      <div>{{ row.date | date }}</div>
      <div>{{ row.billed | insolcurrency }}</div>
      <div>{{ row.writtenOff | insolcurrency }}</div>
    </div>
  </div>
</div>